import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss'
})
export class TableComponent {
  @Input() id: string = `table-${Math.floor(Math.random() * (999999 - 100000)) + 100000}`;
  @Input() items: any[] = [];
  @Input() totalItems: number = 0;
  @Input() itemsPerPageOptions: number[] = [5, 10, 20, 50];
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  currentPage: number = 1;
  itemsPerPage: number = 10;

  get totalPages(): number[] {
    const totalPagesCount = Math.ceil(this.totalItems / this.itemsPerPage);
    return new Array(totalPagesCount).fill(0).map((x, i) => i + 1);
  }

  get displayedItems(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.items.slice(startIndex, startIndex + this.itemsPerPage);
  }

  changePage(page: number) {
    this.currentPage = page;
    this.pageChange.emit(page);
  }

  changeItemsPerPage() {
    this.currentPage = 1;
    this.pageChange.emit(this.currentPage);
  }
}
